// DOM hooks for the new-task entry flow (OP-2534): the grid moves focus from
// the quick-add row to the new task's date, then to its "+ Add" product
// button, without either control needing a ref threaded through antd's Table.

/** Marks a task row's date cell wrapper, valued with the task id. */
export const TASK_DATE_CELL_ATTR = 'data-task-date-cell';
/** Marks a task's "+ Add" product control wrapper, valued with the task id. */
export const TASK_ADD_INPUT_ATTR = 'data-task-add-input';

const escapeId = (id: string) =>
  typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(id) : id;

const findByAttr = (attr: string, taskId: string) =>
  document.querySelector<HTMLElement>(`[${attr}="${escapeId(taskId)}"]`);

/** Focuses the task's date cell, which opens its date picker. */
export const focusTaskDateCell = (taskId: string): void => {
  findByAttr(TASK_DATE_CELL_ATTR, taskId)
    ?.querySelector<HTMLElement>('[tabindex="0"]')
    ?.focus();
};

/** Focuses the task's "+ Add" product button, so Enter opens the picker. */
export const focusTaskAddInput = (taskId: string): void => {
  findByAttr(TASK_ADD_INPUT_ATTR, taskId)
    ?.querySelector<HTMLButtonElement>('button')
    ?.focus();
};

/** Scrolls the task's row into view, only as far as needed. */
export const scrollTaskRowIntoView = (taskId: string): void => {
  document
    .querySelector<HTMLElement>(
      `.input-tasks-table tr[data-row-key="${escapeId(taskId)}"]`
    )
    ?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
};
